import {Injectable} from '@angular/core';
import {GetCareGroupCountCommand} from '@drl/shared/commands/get-care-group-count.command';
import {ApiService} from '@drl/core/api/api.service';
import {AnyAdapter} from '@drl/core/api/adapters/any-adapter.service';
import {CountAdapter} from '@drl/core/api/adapters/count-adapter.service';
import {Count} from '@drl/core/models';
import {CareGroup} from '@drl/shared/models';
import {HttpParams} from '@angular/common/http';
import {GetCareGroupsCommand} from '@drl/shared/commands/get-care-groups.command';

@Injectable()
export class CareGroupFacadeService {
  constructor(
    private readonly apiService: ApiService,
    private readonly anyAdapter: AnyAdapter,
    private readonly countAdapter: CountAdapter,
  ) {}

  getCareGroupCount() {
    const command: GetCareGroupCountCommand<Count> =
      new GetCareGroupCountCommand(this.apiService, this.countAdapter);
    return command.execute();
  }

  getCareGroups() {
    const command: GetCareGroupsCommand<Partial<CareGroup>> =
      new GetCareGroupsCommand(this.apiService, this.anyAdapter);

    const order = ['createdOn DESC'];
    const queryData = {
      name: true,
      id: true,
    };

    const queryStr = JSON.stringify({
      order,
      fields: queryData,
    });
    command.parameters = {
      query: new HttpParams().set('filter', queryStr),
    };
    return command.execute();
  }
}
